<template>
  <automation-imports-list />
</template>

<script>
import AutomationImportsList from '@/modules/automations/components/AutomationImportsList'
export default {
  name: 'ImportsTab',
  components: { AutomationImportsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/automations/pages/ImportsTab.vue